export default function Testimonial() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-16 items-center">
          <div className="w-full lg:w-3/5">
            <div className="flex items-center gap-3 mb-6">
              <span className="text-xs font-semibold text-secondary-600 uppercase tracking-wider font-label">User Review</span>
            </div>
            <blockquote className="mb-6">
              <span className="font-heading text-4xl md:text-5xl text-accent-500/40 leading-none select-none">&ldquo;</span>
              <p className="font-heading text-xl md:text-3xl lg:text-4xl font-medium text-foreground-950 leading-[1.25] tracking-tight -mt-4">
                The CSSBuy spreadsheet completely changed how I shop. I used to waste hours searching for reliable sellers. Now I just check the weekly updated list and order with confidence.
              </p>
            </blockquote>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-accent-200 flex items-center justify-center">
                <span className="font-heading text-sm font-bold text-accent-700">JD</span>
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-950 font-label">James D.</p>
                <div className="flex items-center gap-1.5">
                  <span className="text-xs text-secondary-600 font-body">Verified Buyer</span>
                  <span className="text-accent-500 text-xs">★★★★★</span>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-2/5">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-background-200/50">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20authentic%20portrait%20of%20a%20confident%20person%20with%20relaxed%20expression%20against%20warm%20off%20white%20studio%20backdrop%2C%20soft%20diffused%20lighting%20from%20large%20window%20left%20side%2C%20genuine%20natural%20pose%20with%20slight%20smile%2C%20editorial%20lifestyle%20photography%20with%20shallow%20depth%20of%20field%2C%20cream%20and%20warm%20beige%20tones%2C%20modern%20approachable%20professional%20look&width=600&height=750&seq=testimonial-portrait-v3&orientation=portrait"
                alt="Verified CSSBuy spreadsheet user"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}